module.exports = __webpack_public_path__ + "static/img/error-warning-line.54a840b5.svg";